import { cn } from '@/lib/utils';

interface RichTextContentProps {
  html: string | null | undefined;
  className?: string;
}

/**
 * Renders HTML produced by the RichTextEditor.
 * Uses the same CSS rules as the editor so output looks identical.
 */
export const RichTextContent = ({ html, className }: RichTextContentProps) => {
  if (!html) return null;

  return (
    <div
      className={cn('rte-editor text-sm text-gray-700', className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
